<script>
    import PreviewElement from "./PreviewElement";
    import EmbedElement from "../../components/pagesbuilder/elements/EmbedElement";

    export default {
        name: "PreviewEmbedElement",
        mixins: [
            PreviewElement,
            EmbedElement
        ]
    }
</script>
